export class CalendarHoliday {
    id: number;
    holidayDate: Date;
    holidayName: string;
    createdBy: string;
    createdUtcDate: string;
    lastModifiedBy: string;
    lastModifiedUtcDate: string;
}